<script>
export default {
  props: {
    index: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    pages() {
      return [...Array(4).keys()]
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.wrapper">
      <div
        v-for="page in pages"
        :key="page"
        :class="{
          [$style.circle]: true,
          [$style.active]: index === page,
        }"
      />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  padding: 12px 0;
  margin: 0;
  position: relative;
}

.wrapper {
  display: inline-block;
  position: relative;
}

.circle {
  background: var(--color-secondary);
  border: 1px solid var(--color-secondary);
  border-radius: 50%;
  display: inline-block;
  height: 10px;
  margin-right: 15px;
  position: relative;
  width: 10px;
  z-index: 1;

  &:last-child {
    margin-right: 0;
  }
}

.active {
  background-color: var(--color-primary);
  border: 1px solid var(--color-primary);
}
</style>
